/* eslint-disable no-console */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Box from 'ui-box';
import { Button } from 'antd';
import InputSelectField from '../form-helpers/InputSelectField';
import { FormInputArea } from '../form-helpers/FormField';
import LoadingSpinner from '../../common/LoadingSpinner';
import { errorNotification } from '../../../utils/notification-helpers';
import SharedWithList from './SharedWithList';

const data = [
  {label: 'Medical Condition 1', value: 'Medical Condition 1'},
  {label: 'Medical Condition 2', value: 'Medical Condition 2'},
  {label: 'Medical Condition 3', value: 'Medical Condition 3'},
  {label: 'Medical Condition 4', value: 'Medical Condition 4'},
]

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  }
}

function MedicalConditionForm({ onSubmitBtnText, onSubmitForm, dataMedicalHistory }) {
  const { t } = useTranslation(['common', 'medical-history']);

  const FormSchema = useMemo(
    () =>
      Yup.object().shape({
        medical_conditions: Yup.string().required(t('form.error.required'))
      }),
    [t]
  );

  const initialValues = {
    medical_conditions: dataMedicalHistory && dataMedicalHistory.medical_conditions ? dataMedicalHistory.medical_conditions : '',
  };

  return (
    <div style={{ width: '100%', textAlign: 'left' }}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={FormSchema}
        onSubmit={async (values, { resetForm }) => {
          const dataForm = dataMedicalHistory ?? {};
          dataForm.medical_conditions = values.medical_conditions
          resetForm({ values: initialValues });
          onSubmitForm(dataForm)
        }}
      >
        {({ isSubmitting, isValid, setFieldValue }) => {
          return (
            <Form>
              <fieldset disabled={isSubmitting}>
                <FormInputArea
                  name="medical_conditions"
                  style={{ width: '100%', padding: '3%' }}
                  formItemLayout={formItemLayout}
                  onChange={(e) => setFieldValue("medical_conditions", e.target.value)}
                  rows={6}
                />
                {/* <InputSelectField
                  name="enterMedicalCondition"
                  label={t('medical-history:medicalCondition.form.enterMedicalCondition.label')}
                  placeholder={t('medical-history:medicalCondition.form.enterMedicalCondition.placeholder')}
                  options={data}
                />
                <Box>
                  <SharedWithList
                    title={t('medical-history:medicalCondition.form.yourMedicalCondition.label')}
                    emptyTitle={t('medical-history:medicalCondition.form.yourMedicalCondition.noSelected')}
                    list={[]}
                    onRemove={onRemove} />
                </Box> */}
                <Box paddingTop={15}>
                  <Button
                    disabled={isSubmitting || !isValid}
                    loading={isSubmitting}
                    htmlType="submit"
                    type="primary"
                    size="large"
                    block
                  >
                    {isSubmitting ? <LoadingSpinner position="full" transparent={false} /> : onSubmitBtnText}
                  </Button>
                </Box>
              </fieldset>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

MedicalConditionForm.defaultProps = {
  onSubmitBtnText: 'Save & Update',
};

const { string, func } = PropTypes;

MedicalConditionForm.propTypes = {
  onSubmitBtnText: string,
  onSubmitForm: func.isRequired,
  dataMedicalHistory: PropTypes.objectOf(PropTypes.any).isRequired
};

export default MedicalConditionForm;
